import { userService } from '../../reducers/permissions/userSlice';
import stateStore from '../../stateStore';

export const isAuthenticated = () => {
  return userService.selectors.isAuthenticated(stateStore.getState());
};
